import React from "react";
import BaseCheckboxInput from "oc-ui/react/CheckboxInput";

export default class NumberInput extends BaseCheckboxInput {

    classNameGroup() {
        return `input-wrapper ${this.props.className || ''} ${this.props.hidden?"disappear":"appear"}`;
    }

}
